import queryString from 'query-string'

const dataLayerScript = () => {
  const classes = {
    links: '[data-header-link]'
  }
  
  window.dataLayer = window.dataLayer || {}
  const links = document.querySelectorAll(classes.links)
  
  if (!links) return null
  
  let isFind = Array.from(links).find(link => queryString.stringifyUrl({
    url: link.getAttribute('href'),
  }) === queryString.stringifyUrl({
    url: window.location.href,
  }))
  
  if (window.dataLayer?.push && isFind) {
    window.dataLayer.push({
      'page': {
        lang: document.documentElement.lang.slice(0, 2),
        category: isFind.getAttribute('data-header-link').toLocaleLowerCase().trim()
      }
    })
  }
}

export default dataLayerScript;
